export enum routeContants {
  DASHBOARD = "/",
  DASHBOARD_DETAIL = "/dashboard/detail",
  LOGIN = "/login",
  MYMAIL = "/my-mail",
  DEFINITIONS = "/definitions",
  FACILITY_DEFINITIONS = "/definitions",
  MARKET_DEFINITIONS = "/definitions/markets",
  TEST_ONE = "/definitions/test-one",
  TEST_TWO = "/definitions/test-two",
  BOARD_DEFINITIONS = "/definitions/boards",
  OTHER_AGENCY_DEFINITIONS = "/definitions/other-agency",
  // TEMPLATE_DEFINITIONS = "/definitions/templates",
  AGENCY_MARKETS_DEFINITIONS = "/definitions/agency-markets",
  RESERVATION_MONITOR = "/reservation-monitor",
  CHATS = "/messages",
  NOTIFICATIONS = "/notifications",
  USER_DEFINITIONS = "/definitions/users",
  ROOM_DEFINITIONS = "/definitions/rooms",
  NOTCONFRIM_DEFINITIONS = "/definitions/not-confirms",
  ENRTRY_LIST = "/entry-list",
  HELP_USERMANUAL_USER_MANUAL = "/help/user-manual/user-manual",
  HELP_USERMANUAL_NEWS = "/help/user-manual/news",
  HELP_FAQ = "/help/faq",
  HELP_CONTACT_US = "/help/contact-us",
  ACTIONS = "/definitions",
  ACTION_CREATE = "/spo/create",
  ACTION_HISTORY = "/spo/history",
  ACTION_REPORTS = "/spo/report",
  PARAMETERS = "/parameters",
  OFFERS = "/offer/list",
  TOURISM_NEWS = "/tourism-news",
  AGENCIES = "/agencies",
  PMS_INTEGRATIONS = "/pms-integrations",
  STOP_FREE_SALE = "/stop-free-sale",
  STOP_FREE_SALE_ADD = "/stop-free-sale/add",
  STOP_FREE_SALE_SENDED = "/stop-free-sale/sended",
  STOP_FREE_SALE_REPORT = "/stop-free-sale/report",
  STOP_FREE_SALE_MESSAGE = "/stop-free-sale/message",
  STOP_FREE_SALE_LIST = "/stop-free-sale/list",
  STOP_FREE_SALE_DETAIL = "/stop-free-sale/detail",
  STOP_FREE_SALE_CREATE = "/stop-free-sale/create",
  FACT_SHEET_DASHBOARD = "/fact-sheet/dashboard",
  RES_DISPLAY = "/reservation-display",
  OLD_RES_DISPLAY = "/DisplayReservations.aspx",
  PAYMENT = "/payment",
  OTHERS = "#",
  USER_ACCOUNT = "/user-account",
  HOTEL_ACCOUNT = "/hotel-account",
}